import { fetchInstance } from '@/utils/fetchInstance.ts';

export interface TradePokemon {
  ownedPokemonId: string;
  nickname: string;
  pokemonId: string;
  realname: string;
  level: number;
  isShiny: boolean;
  sprite: string;
}

export interface TradeParticipant {
  userId: string;
  username: string;
  pokemon: TradePokemon | null;
}

export type TradeStatus =
  | 'pending_a_pick'
  | 'pending_b_pick'
  | 'pending_confirm'
  | 'completed'
  | 'cancelled'
  | 'expired';

export interface Trade {
  tradeId: string;
  status: TradeStatus;
  initiatorConfirmed: boolean;
  recipientConfirmed: boolean;
  expiresAt: string;
  initiator: TradeParticipant;
  recipient: TradeParticipant;
}

export const getTrade = (tradeId: string): Promise<Trade> =>
  fetchInstance.get<Trade>(`trades/${tradeId}`);

export const selectTradePokemon = (
  tradeId: string,
  pokemonId: string
): Promise<Trade> =>
  fetchInstance.put<Trade>(`trades/${tradeId}/pokemon`, { pokemonId });

export const confirmTrade = (tradeId: string): Promise<Trade> =>
  fetchInstance.put<Trade>(`trades/${tradeId}/confirm`);

export const cancelTrade = (tradeId: string): Promise<Trade> =>
  fetchInstance.put<Trade>(`trades/${tradeId}/cancel`);